import React from 'react';
import "./Recipe_card.css"

const Recipe_card = ({ recipe }) => {
    return ( 
        <div className="Recipe_card" onClick={() =>
        window.open(recipe['recipe']['url'])}>
        <img className="Recipe_card_img"src={ recipe ['recipe']['image']} />
            <p className="Recipe_card_name">{recipe['recipe']['label']}</p>
            
        </div>
     );
}
 
export default Recipe_card;